import { ContactsLastImportId } from 'modules/contacts/contacts-import/types/contacts-import-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

export const useApproveContactsImport = () => {
  const { t } = useLocoTranslation()

  const { fetcher, isFetching } = useFetch({
    method: RequestMethodsEnum.get,
  })
  return {
    fetcherApproveContactsImport: (id: ContactsLastImportId) =>
      fetcher(`/api/dashboard/contact/contacts/import/${id}/approve`),
    isFetchingApproveContactsImport: isFetching,
  }
}
